import { render, staticRenderFns } from "./UserAccountsModal.vue?vue&type=template&id=276ca1c1"
import script from "./UserAccountsModal.vue?vue&type=script&lang=js"
export * from "./UserAccountsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports